<template>
  <div :class="{'card-with-border': showMoreLess}">
    <card-panel-list>
      <recommended-jobs-card-list-item
        v-for="(item, index) in items"
        :key="item.id"
        :title="item.title"
        :recommended-job-id="item.id"
        :job-code="item.job_code"
        :is-visible="!item.isHidden && (index < showItemsAmount || isAllItemsShown)"
        :need-review="item.need_review"
        :location="item.location"
        :salary="item.annual_salary"
        :interested="item.interested"
        :clickable="clickable"
        @click="$emit('on-item-click', item)">
      </recommended-jobs-card-list-item>
    </card-panel-list>

    <show-more-less
      v-if="showMoreLess"
      @show-more="$emit('on-show-more')"
      @show-less="$emit('on-show-less')">
    </show-more-less>
  </div>
</template>

<script>

import ShowMoreLess from 'top20common/components/ShowMoreLess';
import CardPanelList from 'top20common/components/card-panel/CardPanelList';

import RecommendedJobsCardListItem from '../recommended-jobs/RecommendedJobsCardListItem';

export default {
  props: {
    items: Array,
    clickable: Boolean,
    showItemsAmount: Number,
    isAllItemsShown: Boolean,
    showMoreLess: Boolean
  },
  components: {
    CardPanelList,
    RecommendedJobsCardListItem,
    ShowMoreLess
  }
};
</script>

<style lang="scss" scoped>
.card-with-border .card-panel-list > *:last-child {
  padding-bottom: 10px;
  border-bottom: 1px solid var(--light-gray);
}

/deep/ .show-wrapper {
  padding: 5px 0 15px;
}
</style>
